import { render, staticRenderFns } from "./DangKyChuongTrinhListSuccess.vue?vue&type=template&id=881613d2&"
import script from "./DangKyChuongTrinhListSuccess.vue?vue&type=script&lang=js&"
export * from "./DangKyChuongTrinhListSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports